export const apiSignature = {
    USER_ADD_CUSTOMER : "users/addCustomer",
    USER_VERIFY:'users/verifyCustomer',
    USER_DATA:'fetchUserData',
    IS_USER_VERIFY:'isUserVerify',
    USER_UPDATE_CUSTOMER:"user/updateCusomer"
}